import { useLang } from "../../i18n/LanguageContext";

export default function ServiceTabs({ active, onSelect }) {
  const { t } = useLang();
  return (
    <div className="flex flex-wrap justify-center gap-2 mb-12 max-w-5xl mx-auto">
      {t.services.tabs.map((tab, i) => (
        <button
          key={i}
          onClick={() => onSelect(i)}
          aria-label={`Show ${tab} services`}
          className={`px-6 py-3 rounded text-xs font-black uppercase tracking-widest border transition-all cursor-pointer ${
            active === i
              ? "bg-[#F28C18] text-black border-[#F28C18]"
              : "bg-white/5 text-zinc-400 border-white/5 hover:border-white/20"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
